import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

// Configure dayjs with timezone plugins
dayjs.extend(utc);
dayjs.extend(timezone);

// Albania timezone - using UTC+1 consistently
export const ALBANIA_TIMEZONE = 'Etc/GMT-1'; // This gives UTC+1

// Set default timezone to Albania
dayjs.tz.setDefault(ALBANIA_TIMEZONE);

/**
 * Get current time in Albania timezone
 */
export const nowInAlbania = () => dayjs().tz(ALBANIA_TIMEZONE);

/**
 * Format a date string/Date object to Albania timezone
 * Handles UTC dates from backend correctly
 */
export const formatInAlbania = (
  date: string | Date,
  format = 'DD-MM-YYYY HH:mm'
) => {
  // If it's a string with 'Z' (UTC), parse it as UTC first
  if (typeof date === 'string' && date.endsWith('Z')) {
    return dayjs.utc(date).tz(ALBANIA_TIMEZONE).format(format);
  }
  // Otherwise, treat as local time and convert to Albania timezone
  return dayjs(date).tz(ALBANIA_TIMEZONE).format(format);
};

/**
 * Convert a date to Albania timezone
 * Handles UTC dates from backend correctly
 */
export const toAlbaniaTime = (date: string | Date) => {
  // If it's a string with 'Z' (UTC), parse it as UTC first
  if (typeof date === 'string' && date.endsWith('Z')) {
    return dayjs.utc(date).tz(ALBANIA_TIMEZONE);
  }
  // Otherwise, treat as local time and convert to Albania timezone
  return dayjs(date).tz(ALBANIA_TIMEZONE);
};

export { dayjs };
